import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Input, Form, FormGroup, Label } from "reactstrap";
const Columns = (fechas) => {
  let columns = [
    {
      id: "name",
      name: "Técnico",
      selector: (row) => row.name,
      sortable: false,
    },
  ];
  fechas.map((d) => {
    columns.push({
      id: d,
      name: d,
      selector: (row) => (row[d] ? row[d] : 0),
      sortable: false,
    });
  });

  columns.push({
    id: "noInstallations",
    name: "Total",
    selector: (row) => row.noInstallations,
    sortable: false,
  });
  return columns;
};

export default Columns;

//vaneton beicli
